import { memo, useEffect } from "react";
import { useAtomValue } from 'jotai';
import { currentProjectAtom } from "~/stores/ProjectStore";
import { isMapLoadedDoneAtom } from "../stores/mapStore";
import { projectMembersWithRolesAtom } from "../Member/MemberStore";
import { availableFormsAtom, allCollectFormsMapAtom } from "../panels/GeocollectDatatablePanel/atoms/CollectFormAtoms";
import CollectItemsMapUtils from "../utils/CollectItemsMapUtils";

const CollectItemsMapController = () => {
  const currentProject = useAtomValue(currentProjectAtom);
  const isMapLoadedDone = useAtomValue(isMapLoadedDoneAtom);
  const members = useAtomValue(projectMembersWithRolesAtom);
  const availableForms = useAtomValue(availableFormsAtom);
  const allFormsMap = useAtomValue(allCollectFormsMapAtom);

  useEffect(() => {
    CollectItemsMapUtils.setMembers(members);
  }, [members]);

  useEffect(() => {
    const forms = availableForms.length > 0 ? availableForms : Object.values(allFormsMap);
    CollectItemsMapUtils.setForms(forms);
  }, [availableForms, allFormsMap]);

  useEffect(() => {
    if (!isMapLoadedDone || !currentProject?.id) {
      return;
    }

    CollectItemsMapUtils.addToMap(currentProject.id);

    return () => {
      CollectItemsMapUtils.removeFromMap();
    };
  }, [isMapLoadedDone, currentProject?.id]);

  return null;
};

export default memo(CollectItemsMapController);